import React from "react";
import "./FieldPhone.scss";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import classNames from "classnames";

interface IProps {
  children?: React.ReactNode;
}

const FieldPhone: React.FC<any> = ({label, isError, size, onFocus, onBlur,  ...rest}) => {
  const [focus, setFocus] = React.useState(false);

  const handleFocus = (...arg) => {
    setFocus(true);
    if(onFocus){
      onFocus(arg)
    }
  }

  const handleBlur = (...arg) => {
    setFocus(false)
    if(onBlur){
      onBlur(arg)
    }
  }

  const classes = classNames('field-phone', { isError, isFocus: focus }, size);
  return (
    <div className={classes}>

        {/*@ts-ignore*/}
        <PhoneInput
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...rest}
        />
      <label htmlFor="input" className="control-label">
        {label}
      </label>
      <i className="bar" />
    </div>
  );
};

export default FieldPhone;